import { TableClass } from '../../../world/spa/libs/classes';

export default {
	taskTaskRelation() {
		return new TableClass({
			1: {
				typeClass: 1,
				typeClassLiteral: 'startToStart',
				en: "Start to Start",
				it: "Start to Start"
			},
			2: {
				typeClass: 2,
				typeClassLiteral: 'startToFinish',
				en: "Start to Finish",
				it: "Start to Finish"
			},
			3: {
				typeClass: 3,
				typeClassLiteral: 'finishToFinish',
				en: "Finish to Finish",
				it: "Finish to Finish"
			},
			4: {
				typeClass: 4,
				typeClassLiteral: 'finishToStart',
				en: "Finish to Start",
				it: "Finish to Start"
			}
		});
	},
	taskStatus() {
		return new TableClass({
			1: {
				typeClass: 1,
				typeClassLiteral: 'waiting',
				it: "In attesa",
				en: "Waiting"
			},
			2: {
				typeClass: 2,
				typeClassLiteral: 'running',
				it: "In corso",
				en: "Running"
			},
			3: {
				typeClass: 3,
				typeClassLiteral: 'completed',
				it: "Completato",
				en: "Complete"
			}
		});
	},
	projectStatus() {
		return new TableClass({
			6: {
				typeClass: 6,
				typeClassLiteral: 'provisional',
				it: "Provvisorio",
				en: "Provisional"
			},
			1: {
				typeClass: 1,
				typeClassLiteral: 'waiting',
				it: "In attesa",
				en: "Waiting"
			},
			2: {
				typeClass: 2,
				typeClassLiteral: 'running',
				it: "In corso",
				en: "Running"
			},
			3: {
				typeClass: 3,
				typeClassLiteral: 'completed',
				it: "Completato",
				en: "Complete"
			},
			4: {
				typeClass: 4,
				typeClassLiteral: 'invoiced',
				it: "Fatturato",
				en: "Invoiced"
			},
			5: {
				typeClass: 5,
				typeClassLiteral: 'canceled',
				it: "Annullato",
				en: "Canceled"
			}
		});
	},
	employeeExpenseReportStatus() {
		return new TableClass({
			1: {
				typeClass: 1,
				typeClassLiteral: 'approved',
				it: "Approvata",
				en: "Approved"
			},
			2: {
				typeClass: 2,
				typeClassLiteral: 'currencyConversionMising',
				it: "Conversione valute mancante",
				en: "Currency conversion missing"
			},
			3: {
				typeClass: 3,
				typeClassLiteral: 'expensesToApprove',
				it: "Spese da approvare",
				en: "Expenses to approve"
			},
			4: {
				typeClass: 4,
				typeClassLiteral: 'completed',
				it: "Completata",
				en: "Completed"
			}
		});
	},
	tasksNotificationCode() {
		return new TableClass({
			1: {
				typeClass: 1,
				typeClassLiteral: 'projectAssignment',
				it: "Assegnamento progetto",
				en: "Project assignment"
			},
			2: {
				typeClass: 2,
				typeClassLiteral: 'taskAvailable',
				it: "Task pronto",
				en: "Task ready"
			},
			3: {
				typeClass: 3,
				typeClassLiteral: 'taskAvailableJob',
				it: "Task pronto - postazione",
				en: "Task ready - job"
			}
		});
	},
	taskPriority() {
		return new TableClass({
			1: {
				typeClass: 1,
				typeClassLiteral: 'lowest',
				it: "Minima",
				en: "Lowest"
			},
			2: {
				typeClass: 2,
				typeClassLiteral: 'low',
				it: "Bassa",
				en: "Low"
			},
			3: {
				typeClass: 3,
				typeClassLiteral: 'normal',
				it: "Normale",
				en: "Normal"
			},
			4: {
				typeClass: 4,
				typeClassLiteral: 'high',
				it: "Alta",
				en: "High"
			},
			5: {
				typeClass: 5,
				typeClassLiteral: 'highest',
				it: "Massima",
				en: "Highest"
			}
		});
	}
}
